import { useEffect } from 'react';
import {
  CollectionComponetsActions,
  ComponentTypesActions,
  getComponentTypeByIdMultilingual,
  useContentDispatch,
  useContentSelector,
} from '@wajeez-web/stores/content';
import { useParams } from 'react-router-dom';
import { Spin } from '@wajeez-web/components/ui';

import { ComponentTypeCreateForm } from './ComponentTypeCreateForm';
import { ComponentTypeCreateFormWithPrefilledData } from './ComponentTypeCreateFormWithPrefilledData';
import { useGetComponentTypeByIdMultilingual } from '@wajeez-web/components/helpers';
import { ComponentTypeEditForm } from './ComponentTypeEditForm';
import { Server } from '@wajeez/wajeez.microservices';

interface ComponentTypeFormProps {
  type: 'Create' | 'CreateWithPrefilledData' | 'Edit';
  onSubmit: (componentTypeId: number) => void;
  onCancel: () => void;
}

export const ComponentTypeForm = ({
  type,
  onSubmit,
  onCancel,
}: ComponentTypeFormProps) => {
  const { pageId, id } = useParams<{
    pageId: string;
    id: string;
  }>();

  const contentDispatch = useContentDispatch();

  const componentTypesLookups = useContentSelector(
    ({ componentTypes }) => componentTypes.componentTypesLookups
  );
  const componentTypeByIdMultilingual = useGetComponentTypeByIdMultilingual();

  const collectionComponentStatus = useContentSelector(
    ({ collectionComponents }) => collectionComponents.detailsStatus
  );

  useEffect(() => {
    contentDispatch(
      ComponentTypesActions.getComponentTypesLookupsAsync({
        usageType: Server.ComponentUsageType.Component,
      })
    );
  }, []);

  useEffect(() => {
    pageId &&
      contentDispatch(
        CollectionComponetsActions.getCollectionComponentByIdAsync(pageId)
      );
  }, [pageId]);

  useEffect(() => {
    if (id) {
      getComponentTypeByIdMultilingual(Number(id));
    }
  }, [id]);

  return componentTypesLookups.status === 'loading' ||
    collectionComponentStatus === 'loading' ? (
    <Spin />
  ) : (
    <div className="relative w-[800px] mx-auto">
      {type === 'Create' ? (
        <ComponentTypeCreateForm onSubmit={onSubmit} onCancel={onCancel} />
      ) : componentTypeByIdMultilingual.status === 'loading' ? (
        <Spin />
      ) : type === 'CreateWithPrefilledData' ? (
        <ComponentTypeCreateFormWithPrefilledData
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      ) : (
        <ComponentTypeEditForm onSubmit={onSubmit} onCancel={onCancel} />
      )}
    </div>
  );
};
